import { FT } from 'ft'
import { Sprite, Text, TextStyle, Container } from 'pixi.js'
import Mask from '#/components/Mask'
import ScrollView from '#/components/ScrollView'
import { sub as stringSub, length as stringLength } from 'ft/utils/string'

const customFont = new TextStyle({
  fontFamily: 'custom-font',
  fontSize: 48,
  fill: '#d05e20',
})

const usernameStyle = new TextStyle({
  fontFamily: 'sans-serif',
  fontSize: 30,
  fill: '#d05e20',
})

const normalStyle = new TextStyle({
  fontFamily: 'custom-font',
  fontSize: 32,
  fill: '#d05e20',
})

const tempPlusStyle = new TextStyle({
  fontFamily: 'custom-font',
  fontSize: 32,
  fill: '#fb7050',
})

const tempMinusStyle = new TextStyle({
  fontFamily: 'custom-font',
  fontSize: 32,
  fill: '#4f894c',
})

const { rm } = FT

const $recordBox = 'bed-record-box'
rm.addImage($recordBox)

class Record extends Mask {
  constructor(friends, onClose) {
    super()

    const box = new Sprite(rm.texture($recordBox))
    box.anchor.set(0.5, 0)
    box.position.set(this.width / 2, this.height / 2 - box.height / 2)
    this.addChild(box)

    const title = new Text('助力记录', customFont)
    title.anchor.set(0.5, 0)
    title.y = 20
    box.addChild(title)

    this.interactive = true
    this.on('pointerdown', event => {
      if (event.target === this) {
        this.closable = true
      }
    })
    this.on('pointerup', event => {
      event.stopPropagation()

      if (this.closable && event.target === this) {
        this.closable = false
        onClose()
      }
    })

    const view = new ScrollView()
    view.x = -260
    view.y = 70
    const gap = 5

    const items = friends.map(({ name, temp }) => {
      const $username = new Text(name, usernameStyle)

      let isTruncated = false
      // eslint-disable-next-line
      while (true) {
        if ($username.width > 200) {
          isTruncated = true
          const length = stringLength($username.text)
          $username.text = stringSub($username.text, 0, length - 2)
        } else {
          if (isTruncated) {
            $username.text = `${$username.text}…`
          }
          break
        }
      }

      const sentence = temp >= 0 ? '帮你的被窝升温了' : '让你的被窝降温了'
      const $sentence = new Text(`${sentence}`, normalStyle)
      $sentence.x = $username.x + $username.width

      const $temp = new Text(
        `${Math.abs(temp)}°C`,
        temp >= 0 ? tempPlusStyle : tempMinusStyle
      )
      $temp.x = $sentence.x + $sentence.width + gap

      const container = new Container()
      container.addChild($username)
      container.addChild($sentence)
      container.addChild($temp)

      return container
    })
    view.addItems(items)
    view.setSize(520, 360)
    box.addChild(view)
  }
}

export default Record
